import { ResourceType } from 'Enums/ResourceType';
import { ResourceName } from 'Enums/ResourceTypeNames';

export const GetResourceTypeName = (resourceTypeID: number) =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  ResourceName[ResourceType[resourceTypeID]];
